import React from "react";
import Dialog from '@mui/material/Dialog';
import { useDialog } from '../../shared/context';
import { useSnackbar } from '../../shared/context';
import { ReportTrainingDialog } from "../layout/report/ReportTraining";

export const ReportDialog = ({ handleCancel, dialogData, handlexlsx }) => {
  const { showSnackbar } = useSnackbar();
  const report_dialog = useDialog('reportDialog');

  const msg = (message, variant) => {
    showSnackbar({
      vertical: 'top',
      horizontal: 'right',
      message: message,
      variant: variant,
    });
  };

  const handleView = () => {
    console.log(dialogData.type)
    switch (dialogData.type) {
      default:
        return (
          <ReportTrainingDialog
            showSnackbar={msg}
            handleCancel={handleCancel}
            dialogData={dialogData}
            handlexlsx={handlexlsx}
          />
        );
    }
  };

  return (
    <Dialog
      open={report_dialog.isDialogOpen()}
      onClose={report_dialog.closeDialog}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="lg"
      fullWidth
    >
      {handleView()}
    </Dialog>
  )
}